export default [
  { label: "Number", value: "Number" },
  { label: "Decimal", value: "Decimal" },
  { label: "DateTime", value: "DateTime" },
  { label: "TimeDelta", value: "TimeDelta" },
  { label: "Date", value: "Date" },
  { label: "Time", value: "Time" },
  { label: "Checkbox", value: "Checkbox" },
  { label: "ToggleButton", value: "ToggleButton" },
  { label: "Select", value: "Select" },
  { label: "BarRating", value: "BarRating" },
  { label: "StarRating", value: "StarRating" },
  { label: "Checklist", value: "Checklist" },
  { label: "Text", value: "Text" },
  { label: "Textarea", value: "Textarea" },
  { label: "RichTextarea", value: "RichTextarea" },
  { label: "Phone", value: "Phone" },
  { label: "Image", value: "Image" },
  { label: "Email", value: "Email" },
  { label: "URL", value: "URL" },
  { label: "Currency", value: "Currency" },
  { label: "Percent", value: "Percent" }
]
